var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "btn" }, [
    _c(
      "div",
      { class: ["btn-group", _vm.config.flex] },
      _vm._l(_vm.config.buttons, function (item, index) {
        return _c("Button", {
          key: index,
          attrs: { type: "fcdefault" },
          domProps: { textContent: _vm._s(item.text) },
          on: { click: item.btnClick },
        })
      }),
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }